import { Injectable, EventEmitter, Injector } from '@angular/core';
import { VuCommunicationService } from '../vu/vu-communication.service';
import { IVuConnection } from '../vu/connection/vu-connection.interfaces';

@Injectable()
export class RfidCardReaderService {
  private vuCommunicationService: VuCommunicationService;
  private vuConnection: IVuConnection;

  rfidCardScanned: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    protected injector: Injector,
  ) {
    this.vuCommunicationService = injector.get(VuCommunicationService);
    this.vuConnection = this.vuCommunicationService.vuConnection;
    this.vuConnection.eventRfidCardRead.subscribe((rfidCardCode: string) => this.onRfidCardRead(rfidCardCode));
  }

  private onRfidCardRead(barcode: string): void {
    this.rfidCardScanned.emit(barcode);
  }

  rfidCardLedEnable(value: boolean): void {
    if (this.vuCommunicationService.vuHttp != null) {
      this.vuCommunicationService.vuHttp.rfidCardLedEnable(value);
    }
  }

  rfidCardReaderEnable(value: boolean): void {
    this.rfidCardLedEnable(value);
    if (this.vuCommunicationService.vuHttp != null) {
      this.vuCommunicationService.vuHttp.rfidCardReaderEnable(value);
    }
  }
}
